import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../../../Api.js"

import "./FlightCheckout.css";

const formatTime = date =>
    new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

const formatDate = date =>
    new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });


export default function JayrajCheckout() {
    const location = useLocation();
    const results = location?.state?.carddata
    const TraceId = location?.state?.traceId
    const ResultIdx = location?.state?.resultIndex
    console.log("the checkout page is : ", results);
    console.log("the TraceId is : ", TraceId);
    console.log("the ResultIdx is : ", ResultIdx);
    const [fareRule, setFareRule] = useState();
    const [fareQuote, setFareQuote] = useState();

    const segments = results?.Segments?.[0] || []; // array of segments
    const firstSegment = segments[0];
    const stopies = results?.Segments?.[0]

    const fare = results.Fare;
    const rules = results.MiniFareRules?.[0] || [];
    const [ssrData, setSsrData] = useState();

    const [activeSSRTab, setActiveSSRTab] = useState(null);
    const [selectedMeal, setSelectedMeal] = useState(null);
    const [selectedBaggage, setSelectedBaggage] = useState(null);
    const [passengers, setPassengers] = useState([]);


    // Backend sends array inside array







    useEffect(() => {
        if (!ResultIdx || !TraceId) return;

        const fetchFareData = async () => {
            try {
                // 1️⃣ First call Fare Quote API
                const fareQuoteRes = await api.post("/flights/fare-quote", {
                    ResultIndex: ResultIdx,
                    TraceId: TraceId
                });

                const fareQuoteData = fareQuoteRes?.data?.data?.data;
                const treceno = fareQuoteRes?.data?.data?.trace_id
                setFareQuote(fareQuoteData);

                console.log("Fare Quote:", fareQuoteData);

                // ✅ Ensure required data exists before SSR call
                if (!fareQuoteData?.responseData?.Response?.Results?.ResultIndex) {
                    console.warn("ResultIndex missing for SSR call");
                    return;
                }

                const resultin = fareQuoteData?.responseData?.Response?.Results?.ResultIndex
                console.log("the result index is ", resultin)

                // 2️⃣ Call Fare SSR API using Fare Quote data
                const ssrRes = await api.post("/flights/fare-ssr", {
                    ResultIndex: resultin,
                    TraceId: treceno
                });

                setSsrData(ssrRes?.data?.data);

                console.log("SSR Data:", ssrRes?.data?.data);

            } catch (error) {
                console.error("Fare Quote / SSR fetch failed", error);
            }
        };

        fetchFareData();
    }, [ResultIdx, TraceId]);



    // ✅ Normalize SSR data FIRST
    const mealSSR =
        ssrData?.responseData?.Response?.MealDynamic?.[0] || [];

    const baggageSSR =
        ssrData?.responseData?.Response?.Baggage?.[0] || [];

    // ✅ THEN use them in effects
    useEffect(() => {
        if (baggageSSR.length > 0) {
            setActiveSSRTab("BAGGAGE");
        } else if (mealSSR.length > 0) {
            setActiveSSRTab("MEAL");
        }
    }, [baggageSSR.length, mealSSR.length]);


    console.log("the meals are : ", mealSSR)
    console.log("the baggage are ", baggageSSR)

    const fareResult = fareQuote?.responseData?.Response?.Results

    console.log("the fareresult is ", fareResult);

    const passengerCount = fareResult?.FareBreakdown[0]?.PassengerCount
    console.log("the passenger count is ", passengerCount)

    const rows = ssrData?.responseData?.Response?.SeatDynamic?.[0]?.SegmentSeat?.[0]?.RowSeats || [];
    const [selectedSeat, setSelectedSeat] = useState(null);

    const handleSeatClick = (seat) => {
        if (seat.AvailablityType !== 1) return; // not selectable

        if (selectedSeat?.Code === seat.Code) {
            setSelectedSeat(null);
        } else {
            setSelectedSeat(seat);
        }
    };

    // Payload portion








    const totalPassengers =
        typeof passengerCount === "number"
            ? passengerCount
            : (passengerCount?.Adult || 0) +
            (passengerCount?.Child || 0) +
            (passengerCount?.Infant || 0);

    const [contactInfo, setContactInfo] = useState({
        Country: "India",
        CountryCode: "+91",
        ContactNo: "",
        Email: "",
        Address: "",
        City: "",
        PostalCode: ""
    });

    useEffect(() => {
        if (!fareQuote || !totalPassengers) return;

        const list = Array.from({ length: totalPassengers }, (_, index) => ({
            Title: "Mr",
            FirstName: "",
            LastName: "",
            DateOfBirth: "",
            Gender: 1,
            ContactNo: "",
            Email: "",
            PaxType: "1",
            IsLeadPax: index === 0
        }));

        setPassengers(list);
    }, [fareQuote, totalPassengers]);





    const handlePassengerChange = (index, field, value) => {
        setPassengers(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };




    const passengerFare = fareResult?.Fare && {
        Currency: "INR",
        BaseFare: fareResult.Fare.BaseFare,
        Tax: fareResult.Fare.Tax,
        YQTax: 0,
        AdditionalTxnFeePub: 0,
        AdditionalTxnFeeOfrd: 0,
        OtherCharges: 0,
        Discount: fareResult.Fare.Discount,
        PublishedFare: fareResult.Fare.PublishedFare,
        OfferedFare: fareResult.Fare.OfferedFare,
        TdsOnCommission: fareResult.Fare.TdsOnCommission || 0,
        TdsOnPLB: 0,
        TdsOnIncentive: 0,
        ServiceFee: 0
    };


    const baggagePayload = selectedBaggage
        ? [{
            AirlineCode: selectedBaggage.AirlineCode,
            FlightNumber: selectedBaggage.FlightNumber,
            WayType: 1,
            Code: selectedBaggage.Code,
            Description: selectedBaggage.Description,
            Weight: selectedBaggage.Weight,
            Currency: selectedBaggage.Currency,
            Price: selectedBaggage.Price,
            Origin: selectedBaggage.Origin,
            Destination: selectedBaggage.Destination
        }]
        : [];

    const mealPayload = selectedMeal
        ? [{
            AirlineCode: selectedMeal.AirlineCode,
            FlightNumber: selectedMeal.FlightNumber,
            WayType: 1,
            Code: selectedMeal.Code,
            Description: selectedMeal.Description,
            AirlineDescription: selectedMeal.AirlineDescription,
            Quantity: 1,
            Currency: selectedMeal.Currency,
            Price: selectedMeal.Price,
            Origin: selectedMeal.Origin,
            Destination: selectedMeal.Destination
        }]
        : [];

    const seatPayload = selectedSeat
        ? [
            {
                AirlineCode: selectedSeat.AirlineCode,
                FlightNumber: selectedSeat.FlightNumber,
                WayType: 1,
                Code: selectedSeat.Code,
                Description: selectedSeat.Description,
                SeatType: selectedSeat.SeatType,
                Currency: selectedSeat.Currency,
                Price: selectedSeat.Price,
                Origin: selectedSeat.Origin,
                Destination: selectedSeat.Destination
            }
        ]
        : [];



    const passengersPayload = passengers.map(pax => ({
        Title: pax.Title,
        FirstName: pax.FirstName,
        LastName: pax.LastName,
        PaxType: pax.PaxType,
        DateOfBirth: pax.DateOfBirth
            ? `${pax.DateOfBirth}T00:00:00`
            : null,
        Gender: pax.Gender,

        PassportNo: "",
        PassportExpiry: "",

        AddressLine1: pax.IsLeadPax ? contactInfo.Address : "",
        AddressLine2: "",
        City: pax.IsLeadPax ? contactInfo.City : "",
        CountryCode: "IN",
        CountryName: "India",
        Nationality: "IN",

        ContactNo: pax.IsLeadPax ? contactInfo.ContactNo : "",
        Email: pax.IsLeadPax ? contactInfo.Email : "",

        IsLeadPax: pax.IsLeadPax,
        Fare: passengerFare,

        GSTCompanyAddress: null,
        GSTCompanyContactNumber: null,
        GSTCompanyName: null,
        GSTNumber: null,
        GSTCompanyEmail: null,

        Baggage: baggagePayload,
        MealDynamic: mealPayload,
        SeatDynamic: seatPayload
    }));



    const bookingPayload = {
        ResultIndex: results.ResultIndex,
        TraceId: TraceId,
        IsLCC: results.IsLCC ? "1" : "0",
        isoneway: "Yes",
        isDomestic: "Yes",
        IsDomesticReturn: "No",
        Passengers: passengersPayload
    };




    const handleBookFlight = async () => {

        if (!contactInfo.ContactNo || !contactInfo.Email) {
            alert("Please enter contact number and email");
            return;
        }

        try {
            if (results.IsLCC) {
                const res = await api.post("/flights/ticket-for-lcc", bookingPayload);
                console.log("Booking Success:", res.data);
            } else {

                const response = api.post("/flights/book/non-lcc", bookingPayload)
                console.log("the response from non lcc first api", response)
            }

        } catch (err) {
            console.error("Booking Failed:", err);
        }
    };


    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        const calculatePrice = () => {
            if (!fareResult?.Fare) return;

            const baseFare = fareResult.Fare.PublishedFare || 0;



            const baggagePrice =
                selectedBaggage?.Price
                    ? selectedBaggage.Price
                    : 0;

            const mealPrice =
                selectedMeal?.Price
                    ? selectedMeal.Price
                    : 0;

            const seatPrice = selectedSeat?.Price || 0;

            const finalTotal =
                baseFare +
                baggagePrice +
                mealPrice +
                seatPrice;


            setTotalPrice(finalTotal);
        };

        calculatePrice();
    }, [
        selectedMeal,
        selectedBaggage,
        selectedSeat,
        fareResult?.Fare?.PublishedFare,
    ]);





    useEffect(() => {
        const leadPax = passengers.find(p => p.IsLeadPax);
        if (!leadPax) return;

        setContactInfo(prev => ({
            ...prev,
            ContactNo: leadPax.ContactNo,
            Email: leadPax.Email
        }));
    }, [passengers]);

    return (
        <div style={{ maxWidth: "1100px", margin: "auto" }}>
            <div className="pg">
                {/* Top banner */}
                <div className="banner">
                    <div>
                        <div className="bannerTitle">
                            Nice choice! We can’t guarantee this price for long, lock in this flight before it’s gone!
                        </div>
                        <div className="bannerSub">
                            Still unsure? Drop your requirements and we will let you know when the price changes.
                        </div>
                    </div>
                    <div className="bannerImg"></div>
                </div>

                {/* Main section */}
                <div className="wrap1">
                    <div className="grid1">
                        {/* ================= LEFT COLUMN ================= */}
                        <div>
                            {/* Flight section */}
                            <div className="fs-wrap">
                                <div className="fs-top">
                                    <div className="fs-topLeft">{firstSegment.Origin.Airport.CityName} ({firstSegment.Origin.Airport.CityCode}) → {segments[1]?.Destination.Airport.CityName || segments[0]?.Destination.Airport.CityName} ({segments[1]?.Destination.Airport.CityCode || segments[0]?.Destination.Airport.CityCode})</div>
                                    <div className="fs-topRight">{formatDate(firstSegment.Origin.DepTime)} {formatTime(firstSegment.Origin.DepTime)} → {formatDate(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)} {formatTime(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)}</div>
                                </div>

                                {/* Flight 1 */}
                                {
                                    segments.map((seg) => (
                                        <div className="fs-block">
                                            <div className="fs-strip">
                                                <span className="fs-badge">Departure flight:</span>
                                                <span className="fs-stripCity">{seg.Origin.Airport.CityName}</span>
                                                <span className="fs-stripArrow">✈</span>
                                                <span className="fs-stripCity">{seg.Destination.Airport.CityName}</span>
                                                <span className="fs-stripDur"> {Math.floor(seg.Duration / 60)}h {seg.Duration % 60}m</span>
                                            </div>

                                            <div className="fs-body">
                                                <div className="fs-leftRail">
                                                    <div className="fs-logoBox">
                                                        <span className="fs-logoDots">⋯⋯</span>
                                                        <span className="fs-logoMark">↗</span>
                                                    </div>
                                                    <div className="fs-railLine" />
                                                </div>

                                                <div className="fs-mid">
                                                    <div className="fs-timeRow">
                                                        <span className="fs-date">{formatDate(seg.Origin.DepTime)}</span>
                                                        <span className="fs-time">{formatTime(seg.Origin.DepTime)}</span>
                                                        <span className="fs-bigArrow">→</span>
                                                        <span className="fs-date">{formatDate(seg.Destination.ArrTime)}</span>
                                                        <span className="fs-time">{formatTime(seg.Destination.ArrTime)}</span>
                                                    </div>

                                                    <div className="fs-subRow">
                                                        <span className="fs-clock">🕒</span>
                                                        <span className="fs-subBold"> {Math.floor(seg.Duration / 60)}h {seg.Duration % 60}m</span>
                                                    </div>

                                                    <div className="fs-subRow">
                                                        <span className="fs-airline">{seg?.Airline?.AirlineName}</span>
                                                        <span className="fs-flightNo">{seg?.Airline?.AirlineCode}-{seg?.Airline?.FlightNumber}</span>
                                                    </div>

                                                    <div className="fs-routeRow">
                                                        <span className="fs-airport">
                                                            {seg.Origin.Airport.AirportCode} {seg.Origin.Airport.AirportName}
                                                        </span>

                                                        <span className="fs-midPlane">

                                                            <span className="fs-midPlaneIcon">✈</span>

                                                        </span>

                                                        <span className="fs-airport">{seg.Destination.Airport.AirportCode} {seg.Destination.Airport.AirportName}</span>
                                                    </div>
                                                </div>

                                                <div className="fs-right">
                                                    <div className="fs-ribbon">
                                                        <span className="fs-ribbonNotch" />
                                                        Economy
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>

                            {/* Passenger card */}
                            <div className="jr-card">

                                {/* Passenger Section */}
                                {!fareQuote && (
                                    <div style={{ padding: 20 }}>Loading passenger details…</div>
                                )}

                                {fareQuote &&
                                    passengers.map((pax, index) => (
                                        <div className="jr-card" key={index}>
                                            <div className="jr-title">
                                                Passenger {index + 1}
                                                {pax.IsLeadPax && " (Lead Passenger)"}
                                            </div>

                                            <div className="jr-formGrid2">
                                                {/* Title */}
                                                <div className="jr-field">
                                                    <div className="jr-label">Title</div>
                                                    <select
                                                        className="jr-input"
                                                        value={pax.Title}
                                                        onChange={e =>
                                                            handlePassengerChange(index, "Title", e.target.value)
                                                        }
                                                    >
                                                        <option>Mr</option>
                                                        <option>Mrs</option>
                                                        <option>Ms</option>
                                                    </select>
                                                </div>

                                                {/* First Name */}
                                                <div className="jr-field">
                                                    <div className="jr-label">First Name</div>
                                                    <input
                                                        className="jr-input"
                                                        placeholder="Enter First Name"
                                                        value={pax.FirstName}
                                                        onChange={e =>
                                                            handlePassengerChange(index, "FirstName", e.target.value)
                                                        }
                                                    />
                                                </div>

                                                {/* Last Name */}
                                                <div className="jr-field">
                                                    <div className="jr-label">Last Name</div>
                                                    <input
                                                        className="jr-input"
                                                        placeholder="Enter Last Name"
                                                        value={pax.LastName}
                                                        onChange={e =>
                                                            handlePassengerChange(index, "LastName", e.target.value)
                                                        }
                                                    />
                                                </div>

                                                {/* DOB */}
                                                <div className="jr-field">
                                                    <div className="jr-label">Date of Birth</div>
                                                    <input
                                                        type="date"
                                                        className="jr-input"
                                                        value={pax.DateOfBirth}
                                                        onChange={e =>
                                                            handlePassengerChange(index, "DateOfBirth", e.target.value)
                                                        }
                                                    />
                                                </div>

                                                {/* Lead Passenger Contact */}
                                                {pax.IsLeadPax && (
                                                    <>
                                                        <div className="jr-field">
                                                            <div className="jr-label">Mobile Number</div>
                                                            <input
                                                                className="jr-input"
                                                                placeholder="Enter Mobile Number"
                                                                value={pax.ContactNo}
                                                                onChange={e =>
                                                                    handlePassengerChange(index, "ContactNo", e.target.value)
                                                                }
                                                            />
                                                        </div>

                                                        <div className="jr-field">
                                                            <div className="jr-label">Email</div>
                                                            <input
                                                                className="jr-input"
                                                                placeholder="Enter Email"
                                                                value={pax.Email}
                                                                onChange={e =>
                                                                    handlePassengerChange(index, "Email", e.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}





                                <div className="jr-subTitle">Simple Service Request Details</div>
                                {
                                    segments?.map((seg) => (
                                        <div className="jr-ssr2">
                                            <div className="jr-ssrBox2">
                                                <div className="jr-ssrKey2">SECTOR</div>
                                                <div className="jr-ssrVal2">{seg?.Origin?.Airport?.AirportCode} - {seg?.Destination?.Airport?.AirportCode}</div>
                                            </div>
                                            <div className="jr-ssrBox2">
                                                <div className="jr-ssrKey2">CABIN</div>
                                                <div className="jr-ssrVal2">{seg?.CabinBaggage}</div>
                                            </div>
                                            <div className="jr-ssrBox2">
                                                <div className="jr-ssrKey2">CHECK-IN</div>
                                                <div className="jr-ssrVal2">{seg?.Baggage}</div>
                                            </div>
                                            <div className="jr-ssrBox2">
                                                <div className="jr-ssrKey2">OPERATED BY</div>
                                                <div className="jr-ssrVal2">{seg?.Airline?.AirlineCode}</div>
                                            </div>
                                        </div>
                                    ))
                                }


                                <div className="jr-tabs2">
                                    {baggageSSR.length > 0 ?
                                        <button
                                            className={`jr-tab2 ${activeSSRTab === "BAGGAGE" ? "jr-tabActive2" : ""}`}
                                            onClick={() => setActiveSSRTab("BAGGAGE")}
                                        >
                                            🧳 Add Baggage
                                        </button>
                                        : "No Extra Baggege Feature Available"
                                    }

                                    {mealSSR.length > 0 && (
                                        <button
                                            className={`jr-tab2 ${activeSSRTab === "MEAL" ? "jr-tabActive2" : ""}`}
                                            onClick={() => setActiveSSRTab("MEAL")}
                                        >
                                            🍱 Add Meal Preferences
                                        </button>
                                    )}
                                </div>


                                {activeSSRTab === "MEAL" && (
                                    <div className="jr-bagList">
                                        {mealSSR.map((meal) => {
                                            const isSelected = selectedMeal?.Code === meal.Code;
                                            const isNoMeal = meal.Code === "NoMeal";

                                            return (


                                                <div
                                                    key={meal.Code}
                                                    className={`jr-bagRow ${isSelected ? "jr-bagRowSelected" : ""}`}
                                                >
                                                    <div className="jr-bagIconBox">
                                                        <span className="jr-bagIcon">🍱</span>
                                                    </div>

                                                    <div className="jr-bagInfo">
                                                        <div className="jr-bagInfoTop">
                                                            {isNoMeal ? "No Meal" : "Meal"}({meal?.Origin}- {meal?.Destination})
                                                        </div>
                                                        <div className="jr-bagInfoSub">
                                                            {meal.AirlineDescription || "No Meal Selected"}
                                                        </div>
                                                    </div>

                                                    <div className="jr-bagRight">
                                                        <div className="jr-bagPrice2">
                                                            {meal.Currency === "INR" ? "₹" : meal.Currency}{" "}
                                                            {meal.Price.toLocaleString()}
                                                        </div>

                                                        {isSelected ? (
                                                            <div className="jr-selectedPill">
                                                                <span className="jr-checkCircle">✓</span>
                                                                Selected
                                                            </div>
                                                        ) : (
                                                            !isNoMeal && (
                                                                <button
                                                                    className="jr-selectBtn"
                                                                    onClick={() => setSelectedMeal(meal)}
                                                                >
                                                                    Select
                                                                </button>
                                                            )
                                                        )}
                                                    </div>
                                                </div>

                                            );
                                        })}
                                    </div>
                                )}



                                {activeSSRTab === "BAGGAGE" && (
                                    <div className="jr-bagList">
                                        {baggageSSR.map((bag, i) => {
                                            const isSelected = selectedBaggage?.Code === bag.Code;

                                            return (
                                                <div
                                                    key={i}
                                                    className={`jr-bagRow ${isSelected ? "jr-bagRowSelected" : ""}`}
                                                >
                                                    <div className="jr-bagIconBox">
                                                        <span className="jr-bagIcon">🧳</span>
                                                    </div>

                                                    <div className="jr-bagInfo">
                                                        <div className="jr-bagInfoTop">Additional</div>
                                                        <div className="jr-bagInfoSub">
                                                            {bag.Weight === 0 ? "No Baggage" : `${bag.Weight} KG`}
                                                        </div>
                                                    </div>

                                                    <div className="jr-bagRight">
                                                        <div className="jr-bagPrice2">
                                                            ₹ {bag.Price.toLocaleString()}
                                                        </div>

                                                        {isSelected ? (
                                                            <div className="jr-selectedPill">
                                                                <span className="jr-checkCircle">✓</span>
                                                                Selected
                                                            </div>
                                                        ) : (
                                                            <button
                                                                className="jr-selectBtn"
                                                                onClick={() => setSelectedBaggage(bag)}
                                                            >
                                                                Select
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}


                            </div>

                            {/* -------------this is seat selection portion--------------- */}

                            <div className="seat-wrapper">
                                <h2 className="seat-title">Select Your Seat</h2>

                                <div className="aircraft">
                                    <div className="cockpit">✈ Cockpit</div>

                                    {rows.map((row, rowIndex) => (
                                        <div key={rowIndex} className="seat-row">
                                            <span className="row-number">{row.Seats?.[0]?.RowNo}</span>

                                            <div className="seat-group">
                                                {row.Seats.map((seat, index) => {
                                                    const isSelected = selectedSeat?.Code === seat.Code;

                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`seat 
                      ${seat.AvailablityType !== 1 ? "seat-blocked" : ""}
                      ${isSelected ? "seat-selected" : ""}
                    `}
                                                            onClick={() => handleSeatClick(seat)}
                                                        >
                                                            <span className="seat-code">{seat.SeatNo}</span>

                                                            {seat.Price > 0 && seat.AvailablityType === 1 && (
                                                                <span className="seat-price">₹{seat.Price}</span>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Summary */}
                                {selectedSeat && (
                                    <div className="seat-summary">
                                        <h3>Selected Seat</h3>
                                        <p>
                                            Seat <strong>{selectedSeat.Code}</strong> | ₹{selectedSeat.Price}
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* ================= CONTACT INFO ================= */}
                            <div className="jr-card">
                                <div className="jr-title">Contact Info</div>
                                <div className="jr-note">
                                    We require a valid email address to contact you with the details of your booking.
                                </div>

                                <div className="jr-formGrid3">
                                    {/* Country */}
                                    <div className="jr-field">
                                        <div className="jr-label">Country</div>
                                        <select
                                            className="jr-input"
                                            value={contactInfo.Country}
                                            onChange={e =>
                                                setContactInfo({ ...contactInfo, Country: e.target.value })
                                            }
                                        >
                                            <option value="India">India</option>
                                        </select>
                                    </div>

                                    {/* Contact Number */}
                                    <div className="jr-field">
                                        <div className="jr-label">Contact Number</div>
                                        <div className="jr-phoneWrap">
                                            <span className="jr-phoneCode">{contactInfo.CountryCode}</span>
                                            <input
                                                className="jr-input"
                                                placeholder="Enter Your Contact Number"
                                                value={contactInfo.ContactNo}
                                                onChange={e =>
                                                    setContactInfo({ ...contactInfo, ContactNo: e.target.value })
                                                }
                                            />
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="jr-field">
                                        <div className="jr-label">Email</div>
                                        <input
                                            className="jr-input"
                                            placeholder="Enter Your Email"
                                            value={contactInfo.Email}
                                            onChange={e =>
                                                setContactInfo({ ...contactInfo, Email: e.target.value })
                                            }
                                        />
                                    </div>

                                    {/* Address */}
                                    <div className="jr-field">
                                        <div className="jr-label">Address</div>
                                        <input
                                            className="jr-input"
                                            placeholder="Enter Your Address"
                                            value={contactInfo.Address}
                                            onChange={e =>
                                                setContactInfo({ ...contactInfo, Address: e.target.value })
                                            }
                                        />
                                    </div>

                                    {/* City */}
                                    <div className="jr-field">
                                        <div className="jr-label">City</div>
                                        <input
                                            className="jr-input"
                                            placeholder="Enter Your City"
                                            value={contactInfo.City}
                                            onChange={e =>
                                                setContactInfo({ ...contactInfo, City: e.target.value })
                                            }
                                        />
                                    </div>

                                    {/* Postal Code */}
                                    <div className="jr-field">
                                        <div className="jr-label">Postal / Zip Code</div>
                                        <input
                                            className="jr-input"
                                            placeholder="Enter Your Postal Code"
                                            value={contactInfo.PostalCode}
                                            onChange={e =>
                                                setContactInfo({ ...contactInfo, PostalCode: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>


                            <button onClick={handleBookFlight} style={{ display: "flex", width: "100%", backgroundColor: "gold", color: "green", justifyContent: "center", padding: "10px 20px", borderRadius: "10px", border: "none", margin: "10px" }}>Proceed to Pay</button>

                        </div>

                        {/* ================= RIGHT COLUMN ================= */}
                        <div className="rightCol">
                            <div className="card">
                                <div className="title">Fare Summary</div>

                                <div className="rowfare"><span>Adults x 1</span><span></span></div>
                                <div className="rowfare"><span>Base fare:</span><span>{fareResult?.Fare?.BaseFare}</span></div>
                                <div className="rowfare"><span>Tax:</span><span>{fareResult?.Fare?.Tax}</span></div>
                                <div className="rowfare"><span>Discount:</span><span>-{fareResult?.Fare?.Discount}</span></div>
                                {selectedBaggage && (
                                    <div className="rowfare">
                                        <span>Baggage</span>
                                        <span>₹ {selectedBaggage.Price}</span>
                                    </div>
                                )}

                                {selectedMeal && (
                                    <div className="rowfare">
                                        <span>Meal</span>
                                        <span>₹ {selectedMeal.Price}</span>
                                    </div>
                                )}
                                {selectedSeat && (
                                    <div className="rowfare">
                                        <span>Seat Price</span>
                                        <span>₹ {selectedSeat.Price}</span>
                                    </div>
                                )}

                                <div className="rowfare bold"><span>Total:</span><span className="amt">₹ {totalPrice.toLocaleString()}</span>
                                </div>

                                <div className="total">
                                    <span>Total Amount</span>
                                    <span className="amt">₹ {totalPrice.toLocaleString()}</span>
                                </div>
                            </div>

                            <div className="card note">
                                Full payment will be charged to your credit card / net banking when you book this flight.
                                Your bank may convert the payment and charge extra conversion fees.
                            </div>

                            <div className="card">
                                <div className="ref">● {fareResult?.IsRefundable ? "Refundable" : "Non Refundable"}</div>
                                <div className="title">Payment Method</div>
                                <div className="note2">
                                    An online prepayment of ₹ {totalPrice.toLocaleString()} is required to book this flight, you do not need to pay the flight rate at check-in.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
}